import { print } from 'graphql'
import gql from 'graphql-tag'

import axiosql from '../axiosql'

function load() {
    return axiosql('user/graphql', {
        query: print(gql`
            {
                site {
                    refererCredit
                    refereeCredit
                }
            }
        `)
    })
}

export { load }
